import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
const GradingSetupLazy = React.lazy(
	() => import(/* webpackChunkName : 'GradingSetup' */ './components')
);

export default (store) => {
	return {
		path: 'grading-setup/:campusId?',
		element: <AsyncLoading component={<GradingSetupLazy />} />,
		children: [],
	};
};
